module.exports = __webpack_public_path__ + "static/media/img.a4392e05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Contact/ContactMedia/img.jpg
// module id = 246
// module chunks = 0